import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import OdinIcon from '../../odin-icon/odin-icon.component';
import FileActions from './file-actions.component';
import { getFileIcon, isImageFile } from './file-utils';

export interface FileListProps {
  files: File[];
  thumbnails: boolean;
  onRemove: (file: File) => void;
  isUploading?: boolean;
}

export default function FileList({ files, thumbnails = false, onRemove, isUploading = false }: FileListProps) {
  const containerStyles = clsx(
    'flex h-full w-full',
    { 'flex-col p-1': !thumbnails },
    { 'flex-row flex-wrap pl-2 pt-2': thumbnails }
  );

  const itemStyles = clsx(
    'group flex cursor-default',
    { 'p-1 hover:bg-gray-5': !thumbnails },
    { 'max-sm:h-24 max-sm:w-24 sm:w-44 sm:h-44 max-w-full': thumbnails },
    {
      'relative mr-2 mb-2 cursor-default items-center justify-center border border-solid border-primary-2 text-primary-2':
        thumbnails,
    }
  );

  const itemIconStyles = clsx({ 'mr-1': !thumbnails }, { 'mx-1': thumbnails });

  const itemNameStyles = clsx('truncate', { 'flex-2': !thumbnails });

  const { t } = useTranslation();

  return (
    <div className={containerStyles}>
      <div className="w-full text-center mb-2">{t('file-upload-more', 'Click to upload or drop more files here')}</div>
      {files.map((file) => (
        <div
          className={itemStyles}
          key={`${file.name}-${file.lastModified}`}
          onClick={(event) => event.preventDefault()}
        >
          {thumbnails && isImageFile(file.type) && (
            <img
              src={window.URL.createObjectURL(file)}
              className="h-full w-full object-cover"
              title={file.name}
              alt={file.name}
            />
          )}
          {(!thumbnails || !isImageFile(file.type)) && (
            <>
              <OdinIcon icon={getFileIcon(file.type)} className={itemIconStyles} />
              <div className={itemNameStyles} title={file.name}>
                {file.name}
              </div>
            </>
          )}

          {!isUploading && <FileActions file={file} thumbnail={thumbnails} onRemove={onRemove} />}
        </div>
      ))}
    </div>
  );
}
